import React from "react";

export default function NotFoundPage() {
  React.useEffect(() => {
    document.title = "Page non trouvée | Jourgui";
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-[#000080]">404</h1>
          <p className="text-2xl font-semibold text-gray-700 mt-4">
            Page non trouvée
          </p>
          <p className="text-gray-500 mt-2">
            La page que vous recherchez n'existe pas ou a été déplacée.
          </p>
        </div>
        <div className="space-y-4">
          <a
            href="/"
            className="inline-block bg-[#000080] text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Retour à l'accueil
          </a>
          <div>
            <a href="/connexion" className="text-[#000080] hover:underline">
              Se connecter
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
